exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".start-container{margin:2rem 0}.start-container__button{background-color:#24cca8;border-radius:50%;color:#fff;cursor:pointer;font-size:2rem;height:10rem;line-height:10rem;margin:3rem auto;text-align:center;width:10rem}.start-container__high-score{font-size:1.6rem;margin-bottom:3rem;padding-top:1rem;text-align:center}.start-container__rules{text-align:center}.start-container__r__label{font-size:1.4rem}.start-container__r__details{font-size:1.2rem}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/lib/loader.js!./src/components/GameScreens/defaultScreen.scss
// module id = 225
// module chunks = 0